import { NDVIstate } from "./types";
import logger from "../../../../utils/logger";
import { createSlice } from "@reduxjs/toolkit";
import { applyExtraReducer } from "../../weather";
import { DashboardQueryParams } from "@pages/dashboard/phases";
import { createThunk } from "../crops/selector";
import { NDVIElement } from "@baseTypes/service/dashboard/INDVIService";
import { ServerResponse } from "@baseTypes/baseType";
import { isRecord } from "@utils/narrow/isRecord";
import urlcat from "urlcat";
import colors from "@infobis/ui-styles-utils/colors";
import { size } from "lodash";

const initialState: NDVIstate = {
    data: [],
    isApiLoading: true,
    apiError: undefined
}

const log = logger.getLogger("ndvi.dash")
const pallete: { [k: string]: string } = {
    'ndvi': colors.ELEMENTS_CHARTS_13,
    'gli': colors.ELEMENTS_CHARTS_9,
    'ndwi': colors.ELEMENTS_CHARTS_6,
    'msi': colors.ELEMENTS_CHARTS_17
}
export const simpleTransformer = <A, R = Partial<A>,>(transform: (el: A, index: number, len: number) => R) => async (response: ServerResponse<A[]>) => {
    const len = response.data.length
    return ({
        ...response, data: response.data.map((el, index) => {
            return {
                ...el,
                ...transform(el, index, len)
            }
        })
    })
}

export const colorize = <A extends { id?: string | number, color?: string }, >(palette: string[] | Record<string, string>) => {
    const paletteSize = size(palette)
    return (el: A, idx: number, len: number) => {
        const colorFromPalette = isRecord(palette) ? el.id && palette[el.id] || palette[idx % paletteSize] : palette[idx % paletteSize]
        const color = el.color && !el.color.startsWith('#') ? '#' + el.color : colorFromPalette
        return ({
            color
        })
    }
}

type FetchNdviBody = {
    cropRotationIds: string[]
}

const fetchNdvi = createThunk<NDVIElement[], DashboardQueryParams, FetchNdviBody>()(
    {
        url: '/ndvi/summaryNdviForYear',
        transformer: simpleTransformer(colorize(pallete)),
        method: "POST"
    },
    (payload, url) => ({
        url: urlcat(url, {year: payload.year}),
        data: {
            cropRotationIds: payload.cropRotationIds || []
        }
    })
)

const ndviDashboardSlice = createSlice({
    name: 'ndviDashboardSlice',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        applyExtraReducer(builder, fetchNdvi)
    },
})

export const actions = { ...ndviDashboardSlice.actions, fetchNdvi }
export default ndviDashboardSlice.reducer

